"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-michele-all-adige": {
    "4bb5cb0a": [{
      "hkey": "59162a50",
      "slug": "san-michele-all-adige",
      "name": "San Michele all'Adige",
      "primary": true,
      "skipSearch": false
    }],
    "villa-piccola": [{
      "hkey": "59162a50",
      "slug": "san-michele-all-adige",
      "name": "San Michele all'Adige",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;